import { Controller } from "@hotwired/stimulus"

// The custom amount input only takes part when "Vlastná suma" is chosen.
export default class extends Controller {
  static targets = ["custom", "input"]

  toggle() {
    this.inputTarget.disabled = !this.customTarget.checked
    if (!this.inputTarget.disabled) this.inputTarget.focus()
  }
}
